module.exports = __webpack_public_path__ + "img/kefu.b757f356.png";